module.exports = __webpack_public_path__ + "static/fonts/icomoon.67cf5dcb.eot";